const useIsInsideApp = () => {
  const standalone = window.navigator['standalone'];
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isSafari = /safari/.test(userAgent);
  const isIos = /iphone|ipod|ipad/.test(userAgent);

  if (isIos) {
    if (!standalone && isSafari) {
      // Safari
      return false;
    } else if (!standalone && !isSafari) {
      // iOS webview
      return true;
    }
  } else {
    if (userAgent.includes('wv')) {
      // Android webview
      return true;
    } else {
      // Chrome
      return false;
    }
  }
};

export default useIsInsideApp;
